export const CHATMESSAGEBOTTOMMARGIN = 20;
export const CHATMESSAGEBORDERRADIUS = 5;
export const CHATMESSAGECONTENTSIZE = 14;
